<template>
  <div class="trip-planning-dialog" role="dialog" aria-modal="true" :aria-label="title">
    <div class="trip-planning-header">
      <strong>{{ title }}</strong>
      <button ref="close" type="button" :aria-label="english ? 'Close' : '關閉'" @click="$emit('close')">×</button>
    </div>
    <iframe :src="url" :title="title" allow="geolocation" />
    <div class="trip-planning-fallback">
      <a :href="url" target="_blank" rel="noopener noreferrer">{{ english ? 'Page not showing? Open in a new window' : '無法顯示？另開視窗' }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: { type: String, required: true },
    english: { type: Boolean, default: false }
  },
  computed: {
    title () { return this.english ? 'Trip planning' : '路線規劃' }
  },
  mounted () {
    this.previousFocus = document.activeElement
    this.previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    this.$refs.close.focus()
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy () {
    document.body.style.overflow = this.previousOverflow
    document.removeEventListener('keydown', this.onKeydown)
    if (this.previousFocus) this.previousFocus.focus()
  },
  methods: {
    onKeydown (event) {
      if (event.key === 'Escape') this.$emit('close')
      // iframe 內的鍵盤事件不會冒泡；固定關閉按鈕始終可用。
      if (event.key === 'Tab') {
        const links = this.$el.querySelectorAll('button, iframe, a')
        if (event.shiftKey && document.activeElement === links[0]) {
          event.preventDefault()
          links[links.length - 1].focus()
        } else if (!event.shiftKey && document.activeElement === links[links.length - 1]) {
          event.preventDefault()
          links[0].focus()
        }
      }
    }
  }
}
</script>

<style scoped>
.trip-planning-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}
.trip-planning-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: 20px;
}
.trip-planning-header button {
  width: 44px;
  height: 44px;
  border: 0;
  background: transparent;
  color: #333;
  font-size: 28px;
  cursor: pointer;
}
iframe { flex: 1; width: 100%; min-height: 0; border: 0; }
.trip-planning-fallback { padding: 6px 16px; text-align: right; font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/components/TripPlanningDialog.vue